<template>
  <div id="page-service">
  <div class="row">
    <div class="col-12">
      <card>
        <div slot="raw-content" class="table-responsive">
          <div class="row" id="top-tool-bar">
            <div class="col-6">
               <input type="text" v-model="search_value" @input="search" id="search">
            </div>
            <div class="col-6">
              <p-button type="info" if=round @click.native.prevent="modalAddService" id="add-service">
                 Add Services
              </p-button>
            </div>
          </div>
          <loader v-if="loader"/>
          <table class="table table-striped" id="service-tbl">
   <thead>
      <th>Service Name</th>
      <th>Price</th>
      <th>Category</th>
      <th class="action">Action</th>
   </thead>
   <tbody v-if="services.total > 0">
                                    <tr v-for="(service,index) in services.data" :key="index">
                                        <td>{{ service.name }}</td>
                                        <td>{{ service.price }}</td>
                                        <td>{{ service.servicecategory.name }}</td>
                                        <td class="action">
                                              <p-button type="info" round @click.native.prevent="modalEditService(service)">
                                                <span class="ti-pencil"></span>
                                              </p-button>
                                              <p-button type="info" round @click.native.prevent="transaction(service)">
                                                <span class="ti-eye"></span>
                                              </p-button>  
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td align="center" colspan="7" id="no-record">No record found.</td>
                                    </tr>
   </tbody>
   
</table>
        <paginate
            :page-count="total_page"
            :page-range="1"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            v-if="services.total > 0"
            >
          </paginate>
        </div>
      </card>
    </div>
  </div>

    <Modal :showModal="modalVisible" :title="modal_title" @close="closeModalService">
      <loader v-if="loader_save"/> 
      <fg-input
              type="text"
              label="Service Name"
              placeholder="Enter Service Name"
              v-model="info.service_name"
            />
       <fg-input
              type="text"
              label="Price"
              placeholder="Enter Price"
              v-model="info.price"
       />
       
       <fg-input
              type="text"
              label="Description"
              placeholder="Enter Description"
              v-model="info.description"
       />   

       <fg-input
              type="text"
              label="Last Name"
              placeholder="Last Name"
              v-model="info.category"
       />  
       
       <p-button type="info" round @click.native.prevent="addService" id="add-service" v-show="btn_type == 'add'" v-if="add_btn">
            Add
       </p-button> 
       <p-button type="info" round @click.native.prevent="updateService" id="add-service" v-show="btn_type == 'edit'">
            Update
       </p-button>  
       <div style="clear:both;">&nbsp;</div>
    </Modal>

  </div>
</template>
<script>
import api  from "@/static/config.json";
import axios from 'axios'
import Loader from "@/components/Loader";
import Modal from '@/components/Modal';
import Paginate from 'vuejs-paginate'
import VAutocomplete from 'v-autocomplete';
import ItemTemplate from '@/components/ItemTemplate.vue';

export default {
  components:{
    Loader,
    Paginate,
    Modal,
    VAutocomplete,
    ItemTemplate
  },
  data() {
    return {
      loader: false,
      loader_save: false,
      records: {
          success:true
      },
      total_page: 0,
      services:[],
      showAddModal:true,
      modalVisible: false,
      info:{
          id:'',
          service_name: '',
          description: '',
          price:'',
          sale_price:'',
          category_id:''
      },
      search_value:'',
      input_name:'',
      modal_title:'',
      modal_button:'',
      btn_type:'',
      add_btn:true,
      item: {},
      items: [],
      template: ItemTemplate,
    }
  },
  methods:{
    async list(page=1){
           let self = this;
           let limit=10;
           let search_val = this.search_value

           self.page = page;
           self.loader = true;

                await axios.get(api.API_URL+`/service?page=${page}&limit=${limit}&search=${search_val}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false;
                  self.services = data
                  self.total_page = Math.ceil(data.total/limit);

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })
     },

     clickCallback (pageNum){
        console.log(pageNum)
        this.list(pageNum)
    },
    openModalService() {
      this.modalVisible = true;
    },
    closeModalService() {
      this.modalVisible = false;
    },
    addService(){
      
      const token = localStorage.getItem('token');
      this.loader_save = true;
      let self = this;
      this.add_btn = false;
            axios.post(api.API_URL+'/service/store', {
                    name: self.info.service_name,
                    description: self.info.description,
                    price: self.info.price,
                    sale_price: self.info.sale_price,
                    category_id: self.info.category_id,
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader_save = false;
                      self.notifyVue('top', 'center','success','Service Successfully Added','ti-announcement')
                      self.list();
                      self.closeModalService()
                      self.info.first_name = ''
                      self.info.last_name = ''
                      self.info.contact_number = ''
                      self.add_btn = true;
                    })
                    .catch((error) => {
                      try {
                           self.loader_save = false;
                          if(error.response.status==400){
                            alert(error.response.data.error.message)
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                                this.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });

                    
    },
    updateService(){
      const token = localStorage.getItem('token');
      this.loader_save = true;
      let self = this;
            axios.put(api.API_URL+'/service/update/'+self.info.id, {
                    first_name: self.info.first_name,
                    last_name: self.info.last_name,
                    contact_number: self.info.contact_number,
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader_save = false;
                      self.notifyVue('top', 'center','success','Service Successfully Updated','ti-announcement')
                      self.list();
                      self.closeModalService()
                      self.info.first_name = ''
                      self.info.last_name = ''
                      self.info.contact_number = ''
                    })
                    .catch((error) => {
                      try {
                           self.loader_save = false;
                          if(error.response.status==400){
                            alert(error.response.data.error.message)
                            this.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                                this.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });
    },
    notifyVue(verticalAlign, horizontalAlign,type,msg,icon) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        title:msg,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    search(){
        this.list()
    },
    modalAddService(){
      this.modal_title = 'Add Service'
      this.modal_button = 'Add'
      this.openModalService()
      this.btn_type = 'add'
      this.info.first_name = ''
      this.info.last_name = ''
      this.info.contact_number = ''
      this.add_btn = true;
    },
    modalEditService(service){
      this.modal_title = 'Update Service'
      this.modal_button = 'Update'
      this.openModalService()
      this.btn_type = 'edit'
      this.info.first_name = service.first_name
      this.info.last_name = service.last_name
      this.info.contact_number = service.contact_number
      this.info.id = service.id
    },
    transaction(service){
        localStorage.setItem("service_name", service.first_name + ' ' + service.last_name);
        this.$router.push({path: '/transaction/'+service.id})
    },dateToString(date_data){
      var date = new Date(date_data);
      let date_return = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear();
      return date_return;
    },
    getLabel (item) {   
      this.list()
      return item.first_name + ' ' + item.last_name
    },
    updateItems (text) {
      let self = this;
      this.search_value = text;
               axios.get(api.API_URL+`/service?search=${text}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false;
                  self.items = data.data

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })
    },
  },
  created() {
      this.list();
  }
};
</script>
<style>
#service-tbl .btn{padding: 5px 10px!important; margin-right:5px;}
.action{text-align: center;}
#top-tool-bar{padding:10px;}
#add-service{float:right;}
#search{width:50%;}
.pagination li{margin-right:20px;}
.pagination{padding: 10px!important;}
.pagination .page-item.active a{font-weight: bold; background-color: #b6aa62!important;} 
.pagination li a{background: #028f8f; padding: 5px; color: #fff!important; }
#add-service{float:right;}
#no-record{font-weight: bold; font-size: 20px;}
@media screen and (max-width: 600px) {
  .modal{width: 100%!important;}
}

</style>
